import { render, staticRenderFns } from "./listendetial.vue?vue&type=template&id=6b54e331&scoped=true&"
import script from "./listendetial.vue?vue&type=script&lang=js&"
export * from "./listendetial.vue?vue&type=script&lang=js&"
import style0 from "./listendetial.vue?vue&type=style&index=0&id=6b54e331&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b54e331",
  null
  
)

export default component.exports